import { PageHero } from "../components/PageHero";
import { FaqSection } from "../sections/FaqSection";
import { Seo } from "../components/Seo";
import { FAQS } from "../data/content";

export default function FaqPage() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <>
      <Seo title="Häufige Fragen (FAQ)" description="Antworten auf die wichtigsten Fragen zu Energieberatung, Rechnungsanalyse, Kosten, Datenschutz und Anbieterwechsel." path="/faq" schema={schema} />
      <PageHero
        eyebrow="FAQ"
        titleLines={["Häufige", '<span class="font-serif italic text-blue-700">Fragen.</span>']}
        subtitle="Die wichtigsten Antworten rund um Ihre kostenlose, unabhängige Energieberatung."
        breadcrumb={[{ label: "FAQ" }]}
      />
      <FaqSection eyebrow="Wissenswertes" title={<>Alles, was Sie <span className="font-serif italic text-blue-700">wissen</span> müssen.</>} />
    </>
  );
}
